import { eEstadoUsuario } from "../common/enumModel";
import { CompaniaModel } from "../compania/CompaniaModel";
import { ISedeSelectedModel } from "../interfaces/sedes/ISedeSelectedModel";
import { IRolSelectedModel } from "../interfaces/seguridad/IRolSelectedModel";
import { IUsuarioRegistrarModel } from "../interfaces/seguridad/IUsuarioRegistrarModel";
import { SedeSelectedModel } from "../sede/SedeSelectedModel";
import { RolSelectedModel } from "./RolSelectedModel";

export class UsuarioRegistrarModel implements IUsuarioRegistrarModel {
    idUsuario: number;
    codigoUsuario: string;
    idTipo: number;
    nombres: string;
    apellidos: string;
    correo: string;
    password: string;
    idContratista: number;
    // roles: IRolSelectedModel[];
    // sedes: ISedeSelectedModel[];
    selectedRoles: number[];
    selectedSedes: number[];
    selectedCompanias: number[];
    esAdministrador: boolean;
    isLogged: boolean;
    idEstado: number;
    companias : Array<CompaniaModel>;
    companiaDefault: CompaniaModel;

    constructor(){
        this.idUsuario = 0;
        this.codigoUsuario = '';
        this.idTipo = 0;
        this.nombres = '';
        this.apellidos = '';
        this.correo = '';
        this.password = '';
        this.idContratista = 0;
        // this.roles = new Array<RolSelectedModel>();
        // this.sedes = new Array<SedeSelectedModel>();
        this.selectedRoles = new Array<number>();
        this.selectedSedes = new Array<number>();
        this.selectedCompanias = new Array<number>();
        this.esAdministrador = false;
        this.isLogged = false;
        this.idEstado = eEstadoUsuario.HABILITADO;
        this.companias = new Array<CompaniaModel>();
        this.companiaDefault = new CompaniaModel();
    }
}